export default "lib/rdf-cytoscape.css";